import React from 'react';
import { CardTitle, Card, Input, Button, CardContent, withGrid } from '../../../Components';
import { ValidationError } from '../../../Store';
import { media } from '../../../Themes';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import { HelpButton } from '../../Shared/HelpButton';

interface IAgendamentoProps {
  dia: string;
  hora: string;
  abrirModal: () => void;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => any;
  validation: ValidationError<{ data: string }>;
  disabled: boolean;
}

const Grid = withGrid(CardContent);
const CardContentGrid = styled(Grid)`
  grid-template-columns: repeat(12, 1fr);
`;

const InputGrid = styled(Input) <any>`
  grid-column: ${p => p.gridColumn};
  margin: 0;

  ${media.zeroToDesktop(`
    grid-column: 1/12;
  `)}
`;

const ButtonGrid = styled(Button) <any>`
  grid-column: ${p => p.gridColumn};
`;

const StlyedHelpButton = styled(HelpButton)`
  margin: 0px 5px
`;


@observer
export default class AgendamentoCard extends React.Component<IAgendamentoProps>  {
  cardRef: React.RefObject<HTMLDivElement>;

  constructor(props: IAgendamentoProps) {
    super(props);

    this.cardRef = React.createRef();
  }

  render() {
    const { dia, hora, handleChange, validation } = this.props;

    return (
      <Card ref={this.cardRef}>
        <CardTitle>
          Agendamento
          <StlyedHelpButton>
            Selecionar dia e hora, respeitando o prazo mínimo de sete dias a contar da data do depósito
          </StlyedHelpButton>
        </CardTitle>
        <CardContentGrid>
          <InputGrid
            gridColumn='1/4'
            label='Data de apresentação'
            type='date'
            value={dia}
            onChange={handleChange}
            name='dia'
            hasError={validation && validation.data}
            errorMessage={validation && validation.data}
            disabled={this.props.disabled}
          />
          <InputGrid
            gridColumn='4/6'
            label='Horário'
            type='hora'
            placeholder='00:00'
            value={hora}
            onChange={handleChange}
            mask='99:99'
            name='hora'
            hasError={validation && validation.data && validation.data[0]}
            disabled={this.props.disabled}
          />
          <ButtonGrid
            gridColumn='10/14'
            color={'primaryColor'}
            onClick={this.props.abrirModal}
            disabled={!this.props.disabled}
          >
            Editar Agendamento
          </ButtonGrid>
        </CardContentGrid>
      </Card>
    );
  }
}
